module.exports = {"450332100":"恭城镇","450332101":"栗木镇","450332102":"莲花镇","450332103":"嘉会镇","450332104":"西岭镇","450332105":"平安镇","450332201":"三江乡","450332204":"观音乡","450332205":"龙虎乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450332.json
// module id = 2235
// module chunks = 0